function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { CssContainer } from "../../components/container";
import { Link } from "react-router-dom";
import { PageHeader, Ribbon, Card, Pill, Empty, Search, Filters, Delta, Pending } from "../../components/analytics-kit";
import { BaseDataViewComponentAsync } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import ServiceFactory from '../../service';
import { Loader } from '../../components/loaders';
import Error from '../../components/error';
import __JSONbigFactory from 'json-bigint';
var JSONbigString = __JSONbigFactory({
  storeAsString: true
});
import markupParser from "../../functions/markup-parser-two";
import Popover from "../../components/popover";
class MainComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onGoBack", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onExportClick", event => {
      let data = this.props.data;
      let content = markupParser(data.text);
      let instruction = data.instruction;
      instruction = instruction.slice(0, 20);
      let fileName = instruction.replace(/ /g, '_');
      fileName += '_assistant.doc';
      const header = `
    <html xmlns:o='urn:schemas-microsoft-com:office:office'
          xmlns:w='urn:schemas-microsoft-com:office:word'
          xmlns='http://www.w3.org/TR/REC-html40'>
    <head><meta charset='utf-8'><title>Research Assistant</title></head><body>`;
      const footer = '</body></html>';
      const fullHTML = header + content + footer;

      // Create a Blob with the correct MIME type
      const blob = new Blob(['\ufeff', fullHTML], {
        type: 'application/msword'
      });

      // Create a temporary download link
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }
  componentDidMount() {
    publishSearch('Research');
    publishEvent('reset-search', {});
  }
  render() {
    let props = this.props;
    let instruction = props.data.instruction;
    //instruction = instruction.slice(0, 40);
    let title = instruction + ': Assistant';
    let content = markupParser(props.data.text);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view research-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "/Apps"
      }, "Apps"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
        to: "/Research/Assistant"
      }, "Research Assistant"), " \xB7 Answer"),
      title: instruction,
      actions: /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
        onClick: this.onExportClick
      }, "Export")
    }), /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      title: "Answer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-prose",
      dangerouslySetInnerHTML: {
        __html: content
      }
    }))));
  }
}
export class ResearchAssistantDetailViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
  }
  async fetchData() {
    var Service = ServiceFactory.getType('/research-assistant/' + this.props.params.id, 'research');
    var service = new Service();
    try {
      var data = await service.getAsync();
      console.log(data);
      this.allowRender = true;
      this.data = data;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  ResearchAssistantDetailViewComponent
};